import { Link } from 'react-router-dom'
import { useAuth } from '@/shared/auth/AuthProvider'
import { PERM } from '@/shared/auth/types'
import { Icon } from '@/app/icons'
import { cn } from './primitives'

const SHAPE =
  'grid size-10 place-items-center rounded-full bg-gray-100 text-gray-600 transition-colors'

/**
 * The account control in the top bar.
 *
 * <h2>The name moved into the tooltip</h2>
 * That is a real trade: you can no longer tell which account you are in
 * without hovering, which matters most to whoever is juggling several test
 * logins. It buys back the width the bar was spending on a name that never
 * changes, and the account page still says it in full.
 *
 * <h2>Not a menu</h2>
 * It goes straight to the account page rather than opening a dropdown. There
 * are exactly two things behind it — preferences and changing a password — and
 * both already live on that page. A menu with two items is a second click for
 * nothing.
 */
export function ProfileButton() {
  const { user, can } = useAuth()

  const name = user?.name ?? 'Akun'
  const role = user?.roleName
  // Newlines render in a native tooltip, and this is the only place the
  // identity is still spelled out.
  const tooltip = [name, role, 'Buka pengaturan akun'].filter(Boolean).join('\n')

  // The account page lives inside the billing module. Someone with monitoring
  // access only would land on a 403, so they get the same badge without a link
  // rather than a control that is guaranteed to fail.
  if (!can(PERM.PORTAL_BILLING)) {
    return (
      <span className={SHAPE} title={tooltip} aria-label={name}>
        <Icon name="user" className="size-5" />
      </span>
    )
  }

  return (
    <Link
      to="/billing/account"
      title={tooltip}
      aria-label={`${name}. Buka pengaturan akun.`}
      className={cn(
        SHAPE,
        'hover:bg-primary-light hover:text-primary',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
      )}
    >
      <Icon name="user" className="size-5" />
    </Link>
  )
}
